const FieldTypeEnum = {
    NORMAL: "NORMAL",
    MASTER_DATA: "MASTER_DATA",
    GENDER_DROPDOWN: "GENDER_DROPDOWN"
}

export default FieldTypeEnum;

